import JSZip from 'jszip'
import { apiRequest } from './api';

export function validatePdfFile(file) {
    if (!file) {
        return { isValid: false, error: '請選擇檔案' };
    }

    if (file.type !== 'application/pdf') {
        return { isValid: false, error: '只能上傳 PDF 檔案' };
    }

    if (file.size > 5 * 1024 * 1024) { // 5MB limit
        return { isValid: false, error: '檔案大小不能超過 5MB' };
    }

    return { isValid: true, error: null };
}

export function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // Extract base64 data without the data URL prefix
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = (error) => {
            reject(error);
        };
    });
}

export async function convertPdfToExcel(file) {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const result = await apiRequest('POST', '/api/index/convertPdfToExcel', formData)

        return result;
    } catch (error) {
        console.error('Conversion error:', error);
        return { 
            success: false, 
            error: error.message || '轉換失敗，請稍後再試' 
        };
    }
}

// Create a ZIP file from multiple files
export async function createZipFromFiles(files) {
    try {
        // Check if JSZip is available globally
        if (typeof JSZip === 'undefined') {
            // If not available, load it dynamically
            await loadJSZipLibrary();
        }
        
        const zip = new JSZip();
        
        // Add all files to the zip
        for (const file of files) {
            zip.file(file.name, file.data);
        }
        
        // Generate the zip file as a blob
        const zipBlob = await zip.generateAsync({ type: 'blob' });
        return zipBlob;
    } catch (error) {
        console.error('Error creating ZIP file:', error);
        throw new Error('創建 ZIP 檔案失敗');
    }
}

// Function to dynamically load JSZip library if not already available
export async function loadJSZipLibrary() {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
        script.integrity = 'sha512-XMVd28F1oH/O71fzwBnV7HucLxVwtxf26XV8P4wPk26EDxuGZ91N8bsOttmnomcCD3CS5ZMRL50H0GgOHvegtg==';
        script.crossOrigin = 'anonymous';
        script.referrerPolicy = 'no-referrer';
        
        script.onload = () => {
            console.log('JSZip library loaded successfully');
            resolve();
        };
        
        script.onerror = () => {
            console.error('Failed to load JSZip library');
            reject(new Error('Failed to load JSZip library'));
        };
        
        document.head.appendChild(script);
    });
}

// Convert file size to human-readable format
export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// Get file extension from filename
export function getFileExtension(filename) {
    return filename.split('.').pop().toLowerCase();
}

// Check if file is an image
export function isImageFile(file) {
    const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/tiff'];
    return imageTypes.includes(file.type);
}

// Generate a thumbnail for an image file
export function generateImageThumbnail(file) {
    return new Promise((resolve, reject) => {
        if (!isImageFile(file)) {
            reject(new Error('Not an image file'));
            return;
        }
        
        const reader = new FileReader();
        reader.onload = (e) => {
            resolve(e.target.result);
        };
        reader.onerror = () => {
            reject(new Error('Error reading image file'));
        };
        reader.readAsDataURL(file);
    });
}

// Utility function to generate a unique ID
export function generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
}
